import React, { useState, useEffect } from 'react';
import HeaderHero from '../components/Header/HeaderHero/HeaderHero.tsx';
import Card from '../components/Card/Card';
import ContactBar from '../components/Header/ContactBar/ContactBar.tsx';
import ContactFormCard from '../components/ContactForm/ContactFormCard.tsx';
import Testimonials from '../components/Testimonials/Testimonials.tsx';
import FeatureGrid from '../components/FeatureGrid/FeatureGrid.tsx';
import Footer from '../components/Footer/Footer.tsx';
import FAQ from '../components/FAQ/FAQ.tsx';
import BookingModal from '../components/BookingModal/BookingModal.tsx';
import ReviewModal from '../components/ReviewModal/ReviewModal.tsx';
import SimpleButton from '../components/SimpleButton/SimpleButton.tsx';
import Promotions from '../components/Promotions/Promotions.tsx';
import ProjectsShowcase from '../components/ProjectsShowcase/ProjectsShowcase.tsx';
import ServicePrice from '../components/ServiceShowcase/ServiceShowcase.tsx';
import LocationMap from '../components/LocationMap/LocationMap.tsx';
import Loader from '../components/Loader/Loader.tsx';
import ImageSlider from '../components/ImageSlider/ImageSlider.tsx';
import HeroBackground from '../components/HeroBackground/HeroBackground.tsx';
import { usePromotion } from '../hooks/usePromotion.ts';
import { useProject } from '../hooks/useProject.ts';
import { useService } from '../hooks/useService.ts';
import { useAddress } from '../hooks/useAddress.ts';
import { useReview } from '../hooks/useReview.ts';
import { useFAQ } from '../hooks/useFAQ.ts';
import { FaMoneyBillWave, FaBolt, FaShieldAlt, FaSlidersH, FaUtensils, FaTelegram, FaWhatsapp, FaInstagram, FaYoutube, FaStar, FaPaw, FaGift, FaFire, FaCalendarAlt, FaUsers, FaUserFriends, FaClock, FaSun, FaCrown, FaCommentDollar } from 'react-icons/fa';
import { APP_CONSTANTS } from '../utils/constants';
import { visitAnalytics } from '../services/api/methods.ts';
import HeaderHeroD from '../assets/images/HeaderHeroD.jpg';
import HeaderHeroM from '../assets/images/HeaderHeroM.jpg';
import Card1 from '../assets/images/Card1.jpg';
import Card2 from '../assets/images/Card2.jpg';
import Card3 from '../assets/images/Card3.jpg';
import Card4 from '../assets/images/Card4.jpg';
import Card5 from '../assets/images/Card5.jpg';
import logo from '../assets/images/logo.png';
import PH1 from '../assets/images/PH1.png';
import PH2 from '../assets/images/PH2.png';
import PH3 from '../assets/images/PH3.png';
import PH4 from '../assets/images/PH4.png';
import PH5 from '../assets/images/PH5.png';
import PH6 from '../assets/images/PH6.png';
import PH7 from '../assets/images/PH7.png';
import PH8 from '../assets/images/PH8.png';
import PH9 from '../assets/images/PH9.png';
import PH10 from '../assets/images/PH10.png';

const Home = () => {
  const { promotion, loading: loadingPromotion, error: errorPromotion, loadPromotions, setPromotion, setError: setErrorPromotion } = usePromotion();
  const { projects, loading: loadingProjects, loadProjects } = useProject();
  const { service, loading: loadingService, error: errorService, loadServices, setService, setError: setErrorService } = useService();
  const { review, loading: loadingReview, error: errorReview, loadReviews, setReview, setError: setErrorReview } = useReview();
  const { faq, loading: loadingFAQ, error: errorFAQ, loadFAQ, setFAQ, setError: setErrorFAQ } = useFAQ();
  const { address, loading: loadingAddress, loadAddress } = useAddress();

  const [showBookingModal, setBookingModal] = useState(false);
  const [showReviewModal, setReviewModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await loadPromotions();
      await loadProjects();
      await loadServices();
      await loadAddress();
      await loadReviews();
      await loadFAQ();


      await visitAnalytics();
    };
    fetchData();
  }, []);
  return (
    <div style={{ backgroundColor: '#000000', }}>

      <ContactBar
        imageSrc={logo}
        WordButton={APP_CONSTANTS.WORDBUTTON}
      />
      <HeaderHero
        title={APP_CONSTANTS.TITLE}
        subtitle={APP_CONSTANTS.SUBTITLE}
        imageSrc={HeaderHeroD}
      />
      <HeroBackground
        theme={{
          primary: '#7c3aed',
          light: '#a78bfa',
          dark: '#6d28d9',
          glow: 'rgba(124, 58, 237, 0.4)',
          gradientStart: '#0c051a',
          gradientEnd: '#180c2e',
          subtitle: '#c4b5fd'
        }}
      >
        <FeatureGrid
          features={[
            { icon: <FaMoneyBillWave size={28} />, label: 'Не дорого', },
            { icon: <FaBolt size={28} />, label: 'Быстро', },
            { icon: <FaShieldAlt size={28} />, label: 'Надёжно', },
            { icon: <FaSlidersH size={28} />, label: 'Гибко', },
          ]}
        />
        <Card
          title="Сервера от Яндекса"
          description="Ваш сайт работает на надёжной инфраструктуре Яндекса — высокая скорость загрузки и 99,9% доступности."
          imageSrc={Card1}
        />
        <Card
          title="Адаптивный дизайн"
          description="Сайт выглядит идеально на любом устройстве — от смартфона до монитора."
          imageSrc={Card2}
          imageOnLeft={false}
        />
        <Card
          title=".NET + React"
          description="Мы используем мощный бэкенд (.NET) и динамичный фронтенд (React) для стабильной и гибкой работы сайта."
          imageSrc={Card3}
        />
        <Card
          title="Лёгкое масштабирование"
          description="Архитектура сайта позволяет быстро добавлять новые функции и увеличивать нагрузку без простоев."
          imageSrc={Card4}
          imageOnLeft={false}
        />
        <Card
          title="Cайты любой сложности"
          description="От лендингов до корпоративных порталов — чистый код, современный дизайн, быстрая работа."
          imageSrc={Card5}
        />
      </HeroBackground>
      {loadingService ? (
        <Loader />
      ) : service?.length ? (
        <ServicePrice
          title="Наши услуги"
          subtitle="Индивидуальные решения для вашего проекта"
          services={service.map(p => ({
            id: p.Id.toString(),
            title: p.Title,
            price: p.Price || '',
            hasFrom: p.HasFrom,
            unit: p.Unit || '',
            imagePath: p.ImagePath || '',
            description: p.Description,
          }))}
        />
      ) : null}
      <ImageSlider
        images={[
          PH1,
          PH2,
          PH3,
          PH4,
          PH5,
          PH6,
          PH7,
          PH8,
          PH9,
          PH10,
        ]}
        title="Пример сайта"
        subtitle="Сайт визитка для парикмахерской с админ панелью"
      />
      {loadingProjects ? (
        <Loader />
      ) : projects?.length ? (
        <ProjectsShowcase
          title="Наши проекты"
          subtitle="Реальные сайты и цифровые решения, которые уже можно открыть и посмотреть в работе."
          projects={projects.map(project => ({
            id: project.Id.toString(),
            title: project.Title,
            description: project.Description,
            projectUrl: project.ProjectUrl || null,
            imagePath: project.ImagePath || '',
            technologies: (project.Technologies || '').split(',').map(item => item.trim()).filter(Boolean),
          }))}
        />
      ) : null}
      {loadingPromotion ? (
        <Loader />
      ) : promotion?.length ? (
        <Promotions
          title="Специальные предложения"
          subtitle="Уникальные условия для наших клиентов"
          columns={4}
          promotions={promotion.map(p => ({
            id: p.Id.toString(),
            title: p.Title,
            description: p.Description,
            discount: p.Discount || '',
            badge: p.Badge || '',
            icon: p.IconIndex,
            validUntil: new Date(p.ValidUntil).toLocaleDateString('ru-RU')
          }))}
        />
      ) : null}
      <HeroBackground
        theme={{
          primary: '#06b6d4',
          light: '#22d3ee',
          dark: '#0891b2',
          glow: 'rgba(6, 182, 212, 0.4)',
          gradientStart: '#081220',
          gradientEnd: '#0f1735',
          subtitle: '#b4e4ff'
        }}
      >
        <ContactFormCard image={HeaderHeroM} />
      </HeroBackground>
      {loadingFAQ ? (
        <Loader />
      ) : faq?.length ? (
        <FAQ
          title="Часто задаваемые вопросы"
          subtitle="Всё, что вам нужно знать"
          items={faq}
        />
      ) : null}


      {loadingReview ? (
        <Loader />
      ) : review?.length ? (
        <Testimonials
          title="Что говорят наши гости"
          subtitle="Реальные отзывы от людей, которым мы сделали проект"
          items={review}
          onAddReviewClick={() => setReviewModal(true)}
        />
      ) : null}
      <ReviewModal isOpen={showReviewModal} onClose={() => setReviewModal(false)} />
      <HeroBackground
        theme={{
          primary: '#7c3aed',
          light: '#a78bfa',
          dark: '#6d28d9',
          glow: 'rgba(124, 58, 237, 0.4)',
          gradientStart: '#0c051a',
          gradientEnd: '#180c2e',
          subtitle: '#c4b5fd'
        }}
      >
        {loadingAddress ? (
          <Loader />
        ) : address?.length ? (
          <LocationMap
            locations={address.map(a => ({
              id: a.Id.toString(),
              latitude: a.Latitude,
              longitude: a.Longitude,
              address: a.FullAddress,
            }))}
            onLocationSelect={(id) => console.log('Выбран адрес id:', id)}
          />
        ) : null}
      </HeroBackground>
      <Footer
        slogan="Современные решения для вашего бизнеса в сети."
        contacts={[
          {
            label: "Телеграм",
            value: "ТГ:Админ",
            href: "https://t.me/SkyWard_Dmitrii",
          },
          {
            label: "ВКонтакте",
            value: "ВК:Админ",
            href: "https://vk.com/skyward_dmitrii",
          },
          {
            label: "Телеграм",
            value: "ТГ:Заместитель",
            href: "https://t.me/Proton1x",
          },
          {
            label: "ВКонтакте",
            value: "ВК:Заместитель",
            href: "https://vk.com/protonix",
          },
          {
            label: "Адрес",
            value: "Россия, Новокузнецк",
            href: null,
          },
        ]}
        socials={[
          { name: "telegram", url: "https://t.me/SkyWard_GameDev", icon: <FaTelegram /> },
          //{ name: "whatsapp", url: "https://wa.me/79991234567", icon: <FaWhatsapp /> },
          //{ name: "instagram", url: "https://instagram.com/yourprofile", icon: <FaInstagram /> },
          //{ name: "youtube", url: "https://youtube.com/@yourchannel", icon: <FaYoutube /> },
        ]}
        copyright="© 2026 SkyWard. Все права защищены."
      />
    </div>
  );
};

export default Home;
